<template>
    <span>{{ time }}</span>
</template>

<script setup>
import { computed } from 'vue'
import dayjs from 'dayjs'

const props = defineProps({
    time: String,
    format: String,
})
const time = computed(() => dayjs(props.time).format(props.format))
</script>